"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecomRuntime = void 0;
const host_modules_1 = require("@wix/sdk-runtime/host-modules");
exports.ecomRuntime = (0, host_modules_1.createHostModule)({
    navigateToCartPage: ({ channel }) => function navigateToCartPage(...args) {
        return channel.invoke({
            namespace: 'ecom',
            method: 'navigateToCartPage',
            args,
        });
    },
    navigateToCheckoutPage: ({ channel }) => function navigateToCheckoutPage(...args) {
        return channel.invoke({
            namespace: 'ecom',
            method: 'navigateToCheckoutPage',
            args,
        });
    },
    onCartChange: ({ channel }) => function onCartChange(...args) {
        return channel.invoke({
            namespace: 'ecom',
            method: 'onCartChange',
            args,
        });
    },
    openSideCart: ({ channel }) => function openSideCart(...args) {
        return channel.invoke({
            namespace: 'ecom',
            method: 'openSideCart',
            args,
        });
    },
    refreshCart: ({ channel }) => function refreshCart(...args) {
        return channel.invoke({
            namespace: 'ecom',
            method: 'refreshCart',
            args,
        });
    },
});
//# sourceMappingURL=ecom.runtime.js.map